import * as React from 'react';
export const TableContext = React.createContext({
    headerData: null,
    headerRows: null,
    rows: []
});
//# sourceMappingURL=TableContext.js.map